exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".highlightTrBg{\r\n    background:#F5f5f5;       \r\n}\r\n.md-btn {\r\n    width: 20px;\r\n    height: 20px;\r\n    line-height: 20px;\r\n    min-height: 20px;\r\n    vertical-align: top;\r\n    font-size: 10px;\r\n    padding: 0 0;\r\n    margin: 0;\r\n  }\r\n  .scroll-container{\r\n    max-height: 190px;\r\n    overflow-y: scroll;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/UI-PROJECTS/Helpline1097-UI/src/app/outbound-search-records/outbound-search-records.component.css
// module id = ../../../../../src/app/outbound-search-records/outbound-search-records.component.css
// module chunks = 0